export default __webpack_public_path__ + "static/article-10-outrageous-things-you-can-actually-have-at-your-wedding-ba12d5ba78cc1fc53035d16c7d378746.jpg";